import React from 'react'

import { Form, Col } from '_zari/core'

const NumeroSerieFormGroup = ({ value }) => {
  return (
    <Form.Group>
      <Form.Label text='CORRELATIVO' htmlFor='input-numeroSerie-2' md={4} />
      <Col md={8}>
        <Form.InputText value={value} disabled id='input-numeroSerie-2' />
      </Col>
    </Form.Group>
  )
}

export default NumeroSerieFormGroup
